import { keys } from './translator/translation_keys';
export const defaultAssetTypes = {
  Aircraft: [
    'Cargo',
    'Fixed Wing',
    'Helicopter',
    'Other',
    'Passenger',
    'Search and Rescue',
  ],
  'Emergency Equipment': [
    'AEDs',
    'Eye Wash Stations',
    'Fire Safety Equipment',
    'First Aid',
    'Life Preserver',
    'Life Raft',
    'Other',
    'Personal Locator Beacon',
    'Rescue Equipment',
    'Rescue Kit',
    'SCBA',
  ],
  'Heavy Equipment': [
    'Barge',
    'Bulldozer',
    'Compressor (Towable)',
    'Crane',
    'Dump Truck',
    'Excavator',
    'Forklift',
    'Front End Loader',
    'Generator (Towable)',
    'Heavy Truck',
    'Other',
    'Semi / Lorry',
    'Skid-steer',
    'Telehandler',
    'Vac Truck',
  ],
  'Industrial Equipment': [
    'Hydro Test',
    'Mobile Tank',
    'Other',
    'Overhead Crane',
    'Pump',
  ],
  'IT & Office': [
    'Camera',
    'Computer',
    'Furniture',
    'Other',
    'Phone',
    'Tablet',
  ],
  'Light Vehicle': [
    'Car',
    'Motorcycle',
    'Other',
    'SUV',
    'Trailer',
    'Truck',
    'Van',
  ],
  Property: [
    'Appliances',
    'Building',
    'Fixed Tank',
    'Land',
    'Other',
    'Seacan/Container',
  ],
  'Recreation Vehicle': ['ATV', 'Boat', 'Other', 'Snowmobile'],
  'Tools & Equipment': [
    'Battery',
    'Compressor',
    'Drone',
    'Flight Suit',
    'Flight Tools',
    'Hand Tools',
    'Harness',
    'Helmet',
    'Hydraulic Equipment',
    'Immersion Suit',
    'Inspection Equipment',
    'Lanyard',
    'Light',
    'Lifting Equipment',
    'Other',
    'Personal Protective Equipment',
    'Power Tools',
    'Pump',
    'Test Bench',
    'Welder',
  ],
};

export function deepCompareAssetTypes(a, b) {
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) return false;
  for (const key of aKeys) {
    if (!b.hasOwnProperty(key)) return false;
    const aArr = Array.isArray(a[key]) ? [...a[key]].sort() : [];
    const bArr = Array.isArray(b[key]) ? [...b[key]].sort() : [];
    if (aArr.length !== bArr.length) return false;
    for (let i = 0; i < aArr.length; i++) {
      if (aArr[i] !== bArr[i]) return false;
    }
  }
  return true;
}

export const vehicleKeys = [
  'LV',
  'RV',
  'HE',
  'Light Vehicle',
  'Recreation Vehicle',
  'Heavy Equipment',
];

export const assetFields = {
  make: {
    vehicle: {
      title: keys.assets.MAKE,
      tooltip: 'Ford, Audi, etc.',
    },
    asset: {
      title: keys.assets.BRAND,
      tooltip: keys.assets.BRAND,
    },
  },
  model: {
    vehicle: {
      title: keys.assets.MODEL,
      tooltip: 'F-150, Silverado, etc.',
    },
    asset: {
      title: keys.assets.MODEL,
      tooltip: keys.assets.MODEL,
    },
  },
  vin: {
    vehicle: {
      title: keys.assets.VIN,
      tooltip: '5YJSA1DG9DFP13705, etc.',
    },
    asset: {
      title: keys.assets.SERIAL_NUMBER,
      tooltip: '5YJSA1DG9DFP13705, etc.',
    },
  },
};

export const assetTypeStringLookup = {
  'Light Vehicle': 'LIGHT_VEHICLE',
  'Recreation Vehicle': 'RECREATION_VEHICLE',
  'Heavy Equipment': 'HEAVY_EQUIPMENT',
  'IT & Office': 'IT_&_OFFICE',
  'Tools & Equipment': 'TOOLS_&_EQUIPMENT',
  Property: 'PROPERTY',
  'Industrial Equipment': 'INDUSTRIAL_EQUIPMENT',
  'Emergency Equipment': 'EMERGENCY_EQUIPMENT',
  Aircraft: 'AIRCRAFT',
};

export const assetStatus = [
  'Quarantine',
  'Stock',
  'Decommissioned',
  'Active',
  'In Service',
  'Out For Repair',
  'Out For Service',
];

export const asseetColorStringLookup = {
  Stock: 'blue',
  Active: 'green',
  'In Service': 'green',
  Quarantine: 'red',
  Decommissioned: 'red',
  'Out For Repair': 'yellow',
  'Out For Service': 'yellow',
};

export const assetTypeIcons = {
  'Light Vehicle': 'directions_car',
  'Recreation Vehicle': 'snowmobile',
  'Heavy Equipment': 'precision_manufacturing',
  'IT & Office': 'devices',
  'Tools & Equipment': 'plumbing',
  Property: 'home_work',
  'Industrial Equipment': 'factory',
  'Emergency Equipment': 'medical_services',
  Aircraft: 'flight',
};

export const showAssetAlarmClassname = ({ vehicle }) => {
  const { hours, endOfLifeHours, endOfLife } = vehicle || {};
  if (!!hours && !!endOfLifeHours && vehicle.type !== 'Light Vehicle') {
    if (hours >= endOfLifeHours) {
      return 'red';
    } else if (hours >= 0.75 * endOfLifeHours) {
      return 'yellow';
    }
  }

  if (!!endOfLife) {
    const now = new Date();
    const eolDate = new Date(endOfLife);
    const diffInDays = (eolDate - now) / (1000 * 60 * 60 * 24);
    if (0 < diffInDays && diffInDays <= 10) {
      return 'yellow';
    } else if (diffInDays <= 0) {
      return 'red';
    }
  }

  return 'hide';
};

export const endOfLifeDateExpiryCheck = ({ vehicle }) => {
  const { endOfLife } = vehicle || {};
  if (!!endOfLife) {
    const now = new Date();
    const eolDate = new Date(endOfLife);
    const diffInDays = (eolDate - now) / (1000 * 60 * 60 * 24);

    if (diffInDays <= 0) {
      return 'red';
    } else if (diffInDays <= 10) {
      return 'yellow';
    }
  }
  return null;
};
export const endOfLifeHoursCheck = ({ vehicle }) => {
  const { hours, endOfLifeHours } = vehicle || {};
  if (!!hours && !!endOfLifeHours) {
    if (hours >= endOfLifeHours) {
      return 'red';
    } else if (hours >= 0.75 * endOfLifeHours) {
      return 'yellow';
    }
  }
  return null;
};
